var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"subscribe"},[_c('div',{staticClass:"tit"},[_vm._v(" 订阅号已升级成橘猫订阅号独立运营，管理后台已迁移至新网址 ")]),_c('fm-button',{staticClass:"btn",attrs:{"iconLast":"icon-to","round":"","size":"medium"},on:{"click":_vm.toSub}},[_vm._v("访问橘猫订阅号·创作中心")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }